import { FormCard } from '@portal_components/components/FormCard';
import { FormTextInput } from '@portal_components/components/FormTextInput';
import { MeterPointDetails } from '../../types';

interface SiteContactDetailsTabProps {
  readonly: boolean;
}

export const SiteAddressDetailsTab = ({ readonly }: SiteContactDetailsTabProps) => {
  return (
    <FormCard columns={2}>
      <FormTextInput<MeterPointDetails> title="Property Name" name="address.addressName" mandatory readonly={readonly} />
      <FormTextInput<MeterPointDetails> title="Address Line 1" name="address.addressLine1" mandatory readonly={readonly} />
      <FormTextInput<MeterPointDetails> title="Address Line 2" name="address.addressLine2" readonly={readonly} />
      <FormTextInput<MeterPointDetails> title="Address Line 3" name="address.addressLine3" readonly={readonly} />
      <FormTextInput<MeterPointDetails> title="Town" name="address.town" mandatory readonly={readonly} />
      <FormTextInput<MeterPointDetails> title="County" name="address.county" mandatory readonly={readonly} />
      <FormTextInput<MeterPointDetails> title="Postcode" name="address.postcode" mandatory readonly={readonly} />
    </FormCard>
  );
};
